/**
 * Whether the sprint key is held or tapped.
 *
 * Writes to [verbHoldModes](../../../core/input/verbHoldModes.ts), like the other two. The verb
 * that behaves differently from the other two once latched: a toggled sprint ends where a held one
 * would, the moment the player stops asking to go forwards, rather than waiting for a press they
 * have no reason to make. [sprintVerb](../../../core/input/latchedVerbs/sprintVerb.ts) states that
 * rule beside the verb, so this file is only the line that joins a knob to it.
 */

import { choiceApply } from '@/ui/settings/controls/choiceButtons';
import { DEFAULT_HOLD_MODE, setHoldMode } from '@/core/input/verbHoldModes';
import { HOLD_MODE_CHOICE } from '@/ui/settings/holdModeOptions';
import { SETTING_SPRINT_HOLD_LABEL, SETTING_SPRINT_HOLD_HINT } from '@/text/settingsText';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const SPRINT_HOLD_MODE: SettingDefinition = {
  id: 'sprintHoldMode',
  section: 'controls',
  label: SETTING_SPRINT_HOLD_LABEL,
  hint: SETTING_SPRINT_HOLD_HINT,
  control: HOLD_MODE_CHOICE,
  defaultValue: DEFAULT_HOLD_MODE,
  apply: choiceApply((value: string): void => {
    setHoldMode('sprint', value);
  }),
};
